import React, { useEffect, useState } from "react";
import WineItem from "../components/WineItem";
import { FAVORITES_API } from "../components/apiurls";

export const PageFavorites = () => {

  const [favoriteIds, setFavoriteIds] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const userMobile = localStorage.getItem("userMobile");
    console.log("Stored mobile:", localStorage.getItem("userMobile"));
    console.log("User Mobile:", userMobile);
    console.log("Favorites API:", FAVORITES_API);

    if (!userMobile) {
      console.log("No userMobile found in localStorage");
      setLoading(false);
      return;
    }

    const payload = {
      action: "list",
      user_mobile: userMobile,
    };

    console.log("FAVORITES LIST PAYLOAD:", payload);

    fetch(FAVORITES_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("FAVORITES LIST RESPONSE:", data);

        let list = [];

        // API returns array directly
        if (Array.isArray(data)) {
          list = data;
        }

        // API returns { data: [...] }
        else if (Array.isArray(data.data)) {
          list = data.data;
        }

        // API returns { records: [...] }
        else if (Array.isArray(data.records)) {
          list = data.records;
        }

        const formatted = list.map(item => ({
    ...item,
    id: String(item.bm_id)
}));

setFavorites(formatted);

setFavoriteIds(
    formatted.map(item => String(item.bm_id))
);

        const ids = list.map((item) => item.bm_id);

        console.log("Favorite IDs:", ids);

        setFavoriteIds(ids);
      })
      .catch((err) => {
        console.error("Favorites List Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div
        className="products-card"
        style={{ marginTop: "60px", textAlign: "center" }}
      >
        <h3>Loading favourites...</h3>
      </div>
    );
  }
console.log("Favorites passed to WineItem:", favorites);
  return (
    <div className="products-card" style={{ marginTop: "60px" }}>
      {favoriteIds.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px" }}>
          <h3>No favourite brands found.</h3>
        </div>
      ) : (
        <WineItem
          isFavoritesPage={true}
          favoriteIds={favoriteIds}
          favorites={favorites}
          setFavorites={setFavorites}
          setFavoriteIds={setFavoriteIds}
        />
      )}
    </div>
  );
};